<style lang="less" scoped>
@import './main.less';
</style>

<template>
  <div class="main">
    <div class="main-header">
      <!-- <div class="header-middle-con">
        <div class="main-breadcrumb">
          <breadcrumb-nav :currentPath="currentPath"></breadcrumb-nav>
        </div>
      </div> -->
      <!-- <img class="headerLogo" src="../assets/logoAndTxt.png" /> -->
      <img class="headerLogo" src="../assets/xxlogo.jpg" />
      <div class="header-avator-con">
        <div class="user-dropdown-menu-con">
          <Row type="flex" justify="end" align="middle" class="user-dropdown-innercon">
            <Dropdown transfer trigger="hover" @on-click="handleClickUserDropdown">
              <a style="color: #fff">
                <Avatar :src="avatarPath" style="background: #619fe7;margin-left: .10rem;"></Avatar>
                <span class="main-user-name">{{ nickName ? nickName : username }}</span>
                <Icon type="md-arrow-dropdown" />
              </a>
              <DropdownMenu slot="list">
                <!-- <DropdownItem name="ownSpace">{{ '用户中心' }}</DropdownItem> -->
                <DropdownItem name="changePass">
                  {{ '修改密码' }}
                </DropdownItem>
                <DropdownItem name="loginout" divided>
                  {{ '退出' }}
                </DropdownItem>
              </DropdownMenu>
            </Dropdown>
          </Row>
        </div>
        <!-- <message-tip v-model="mesCount"></message-tip> -->
      </div>
    </div>
    <div class="sidebar-menu-con menu-bar">
      <shrinkable-menu :shrink="shrink" @on-change="handleSubmenuChange" :theme="menuTheme" :before-push="beforePush" :open-names="openedSubmenuArr" :menu-list="menuList"> </shrinkable-menu>
    </div>
    <!-- <div class="main-header-con">
      <div v-if="flag" class="messageBanner">
        <img src="../assets/messageBanner.png" width="100%" alt />
      </div> -->
    <!-- 页签 -->
    <!-- <div class="tags-con" v-else>
        <tags-page-opened :pageTagsList="pageTagsList"></tags-page-opened>
      </div> -->
    <!-- </div> -->
    <!--  :style="{left: shrink?'60px':height}" -->
    <div :class="flag === true ? 'single-page-con1' : 'single-page-con'">
      <div id="topAnchor"></div>
      <div class="single-page" >
        <keep-alive :include="cachePage">
          <router-view></router-view>
        </keep-alive>
        <a href="#topAnchor" class="backTop" v-if="isShowBackBtn" @click="toTop"><Icon type="ios-arrow-up" size="30"/></a>
      </div>
    </div>
  </div>
</template>
<script>
import { getRequest } from '@/libs/axios'
import shrinkableMenu from './main-components/shrinkable-menu/shrinkable-menu.vue'
import tagsPageOpened from './main-components/tags-page-opened.vue'
import breadcrumbNav from './main-components/breadcrumb-nav.vue'
import messageTip from './main-components/message-tip.vue'
// import Cookies from 'js-cookie'
// import util from '@/libs/util.js'
// import {
//   // getMessageSendData,
//   userInfo
// } from '@/api/index'

export default {
  components: {
    shrinkableMenu,
    tagsPageOpened,
    breadcrumbNav,
    messageTip
  },
  data() {
    return {
      userInfo: {},
      identityModal: false,
      height: '',
      shrink: false,
      username: '',
      nickName: '',
      userId: '',
      isFullScreen: false,
      openedSubmenuArr: this.$store.state.app.openedSubmenuArr,
      firstThreeNav: [],
      lastNav: [],
      flag: false,
      isShowBackBtn: false
    }
  },
  computed: {
    navList() {
      return this.$store.state.app.navList
    },
    currNav() {
      return this.$store.state.app.currNav
    },
    currNavTitle() {
      return this.$store.state.app.currNavTitle
    },
    menuList() {
      return this.$store.state.app.menuList
    },
    pageTagsList() {
      return this.$store.state.app.pageOpenedList // 打开的页面的页面对象
    },
    currentPath() {
      return this.$store.state.app.currentPath // 当前面包屑数组
    },
    avatarPath() {
      return localStorage.avatorImgPath
    },
    cachePage() {
      return this.$store.state.app.cachePage
    },
    lang() {
      return this.$store.state.app.lang
    },
    menuTheme() {
      return this.$store.state.app.menuTheme
    },
    mesCount() {
      return this.$store.state.app.messageCount
    }
  },
  stompClient: {
    monitorIntervalTime: 100,
    stompReconnect: true,
    timeout(orgCmd) {}
  },
  methods: {
        // 获取通知数据
    async _getNotic() {
      this.$Notice.destroy()
      const res = await getRequest("/v3/notice/getMyNoticeList", null, false);
      if (res.result !== null) {
        res.result.forEach(item => {  
            if(item.displayMode == 2){//（1：弹窗提醒 2：侧边提示）
                this.$Notice.info({
                    title: item.title,
                    desc: item.content,
                    duration: 0,
                    top:50,
                    render: h => {
                        if(item.redirectUrlStatus == 0){
                          return h('span', [
                                item.content
                            ])
                        }else{
                            return h('span', [
                                item.content,
                                h('br'),
                                h('br'),
                                h('a',{ 
                                  attrs: {  
                                    href: item.redirectUrl,   
                                    target: '_blank'
                                  }, 
                              }, '快点击前往看看吧~'),
                            ])
                        }
                        
                    },
                    onClose:function(){
                      if(item.displayDuration == 1){
                          //发生关闭请求
                          getRequest(`/v3/notice/closeNotice?id=${item.id}`, null, false);
                      }
                    }
                });
            }
        }); 
      }
    },
    onScroll(e) {
      this.isShowBackBtn = true
    },
    toTop() {
      setTimeout(() => {
        this.isShowBackBtn = false
      }, 100)
    },
    init() {
      // 菜单
      let pathArr = this.$util.setCurrentPath(this, this.$route.name)
      // this.$store.commit("updateMenulist");
      if (pathArr.length >= 2) {
        this.$store.commit('addOpenSubmenu', pathArr[1].name)
      }
      // let userInfo = JSON.parse(Cookies.get('userInfo'))
      let userInfo = this.$util.localGet('userInfo')

      this.username = userInfo.userName
      this.nickName = userInfo.realName
      this.userId = userInfo.id
      this.checkTag(this.$route.name)
      // // 读取未读消息数
      // getMessageSendData({
      //   userId: userInfo.id,
      //   status: 0
      // }).then(res => {
      //   if (res.success === true) {
      //     this.$store.commit('setMessageCount', res.result.totalElements)
      //   }
      // })
      // this.connectSrv()
      // this.updateUserInfo() // 更新用户信息
      // this.identityModalShow(); //展示“请选择你的身份弹窗”
    },
    onConnected(frame) {
      // console.log("连接ws成功: " + frame);
      // 订阅广播系统通知
      this.$stompClient.subscribe('/topic/subscribe', this.responseCallback, this.onFailed)
      // 订阅点对点 通过用户id指定用户
      this.$stompClient.subscribe('/user/' + this.userId + '/queue/subscribe', this.responseCallback, this.onFailed)
    },
    onFailed(frame) {
      console.log('连接ws失败： ' + JSON.stringify(frame))
    },
    // connectSrv () {
    //   var headers = {}
    //   this.connetWM(ws, headers, this.onConnected, this.onFailed)
    // },
    responseCallback(frame) {
      // console.log("收到消息：" + frame.body);
      this.$store.commit('setMessageCount', this.mesCount + 1)
    },
    disconnect() {
      this.disconnetWM()
    },
    selectNav(name) {
      this.$store.commit('setCurrNav', name)
      this.setStore('currNav', name)
      // 清空所有已打开标签
      // this.$store.commit("clearAllTags");
      this.$router.push({
        name: 'home_index'
      })
      this.$util.initRouter(this)
    },
    toggleClick() {
      this.shrink = !this.shrink
    },
    handleClickUserDropdown(name) {
      if (name === 'ownSpace') {
        this.$util.openNewPage(this, 'ownspace_index')
        this.$router.push({
          name: 'ownspace_index'
        })
      } else if (name === 'ownSpaceOld') {
        this.$util.openNewPage(this, 'ownspace_old')
        this.$router.push({
          name: 'ownspace_old'
        })
      } else if (name === 'changePass') {
        this.$util.openNewPage(this, 'change_pass')
        this.$router.push({
          name: 'change_pass'
        })
      } else if (name === 'loginout') {
        // 退出登录
        this.$store.commit('logout', this)
        this.$store.commit('clearOpenedSubmenu')
        this.$util.localRem('accessToken')
        // 强制刷新页面 重新加载router
        location.reload()
      }
    },
    checkTag(name) {
      let openpageHasTag = this.pageTagsList.some(item => {
        if (item.name === name) {
          return true
        }
      })
      if (!openpageHasTag) {
        //  解决关闭当前标签后再点击回退按钮会退到当前页时没有标签的问题
        this.$util.openNewPage(this, name, this.$route.params || {}, this.$route.query || {})
      }
    },
    handleSubmenuChange(val) {
      // console.log(val)
    },
    beforePush(name) {
      // console.log(name)
      return true
    },
    fullscreenChange(isFullScreen) {
      // console.log(isFullScreen);
    }
    // 去往用户中心
    // toUserCenter() {
    //   console.log('用户中心')
    //   this.$router.push('/student/userCenter')
    // }
  },
  watch: {
    $route(to) {
      this.$store.commit('setCurrentPageName', to.name)
      let pathArr = this.$util.setCurrentPath(this, to.name)
      if (pathArr.length > 2) {
        this.$store.commit('addOpenSubmenu', pathArr[1].name)
      }
      this.checkTag(to.name)
      localStorage.currentPageName = to.name
    },
    lang() {
      this.$util.setCurrentPath(this, this.$route.name) // 在切换语言时用于刷新面包屑
    },
    currentPath(val) {
      // console.log(val[val.length-1].name,'333');
      if (val[val.length - 1].name === 'message_index') {
        this.flag = true
      } else {
        this.flag = false
      }
    }
  },
  mounted() {
    this.init()
    this._getNotic();
    this.height = document.body.clientHeight * 0.2765 + 'px'
    this.$nextTick(function() {
      window.addEventListener('scroll', this.onScroll, true)
    })
  },
  created() {
    // 显示打开的页面的列表
    this.$store.commit('setOpenedList')
  }
}
</script>

<style scoped>
.backTop {
  position: fixed;
  right: 0.3rem;
  bottom: 0.3rem;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 0.48rem;
  height: 0.4rem;
  color: #fff;
  background-color: rgba(0, 0, 0, 0.6);
  border-radius: 0.02rem;
  box-shadow: 0 0.01rem 0.03rem rgba(0, 0, 0, 0.2);
  transition: all 0.2s ease-in-out;
}
.backTop:hover {
  background-color: rgba(0, 0, 0, 0.8);
}
.bgImg1 {
  width: 1.8rem;
  /*必设属性*/
  height: 1.8rem;
  /*必设属性*/
  margin: 0.35rem;
  border-radius: 50%;
  cursor: pointer;
  background-image: url('../assets/people.jpg');
  background-repeat: no-repeat;
  background-position: -0.5rem -0.55rem;
}

.bgImg2 {
  width: 1.8rem;
  /*必设属性*/
  height: 1.8rem;
  /*必设属性*/
  margin: 0.35rem;
  border-radius: 50%;
  cursor: pointer;
  background-image: url('../assets/people.jpg');
  background-repeat: no-repeat;
  background-position: -2.62rem -0.55rem;
}

.bgImg3 {
  width: 1.8rem;
  /*必设属性*/
  height: 1.8rem;
  /*必设属性*/
  margin: 0.35rem;
  border-radius: 50%;
  cursor: pointer;
  background-image: url('../assets/people.jpg');
  background-repeat: no-repeat;
  background-position: -0.5rem -2.61rem;
}
</style>



// WEBPACK FOOTER //
// src/views/Main.vue